import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetContacts = async (customerID) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Contact/getContact/0/${customerID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      const colors = ["error", "info", "warning", "primary", "success"];

      const RandomColor = () => {
        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
      };

      if (response.ok && !data.isError) {   
        const transformedData = data.result.map((item) => ({
            id: item.contactID,
            contact: `${item.firstName} ${item.lastName}`,
            email: item.email,
            initials: `${item.firstName[0]}${item.lastName[0]}`,
            jobTitle: item.jobTitle,
            primary: item.isPrimary,
            firstName: item.firstName,
            lastName: item.lastName,
            customerID: item.customerID,
            status: item.status, 
            phoneNumbers:item.phoneNumbers,
            color: RandomColor(),           
          })).sort((a, b) => (a.primary === b.primary ? 0 : a.primary ? -1 : 1));       
        return transformedData;
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};


export const GetPrimaryContact = async (customerID) => {
  const contacts = await GetContacts(customerID);
  return contacts.find(c => c.primary) || null;
};